import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '@/components/Authentication/Login.vue'
import Timesheet from '@/components/Timekeeping/Timesheet.vue'
import TimesheetDetail from '@/components/Timekeeping/TimesheetDetail.vue'
import AddTimesheet from '@/components/Timekeeping/AddTimesheet.vue'
import AddCurrentTimesheet from '@/components/Timekeeping/AddCurrentTimesheet.vue'
import TimesheetDetailCurrent from '@/components/Timekeeping/TimesheetDetailCurrent.vue'
import Assignments from '@/components/Timekeeping/Assignments.vue'
import Lineups from '@/components/Timekeeping/Lineups.vue'
import RequestPasswordReset from '@/components/Authentication/RequestPasswordReset.vue'
import PasswordResetForm from '@/components/Authentication/PasswordResetForm.vue'
import JobListing from '@/components/Jobs/JobListing.vue'
import JobEdit from '@/components/Jobs/JobEdit.vue'
import JobAdd from '@/components/Jobs/JobAdd.vue'
import UserCredentials from '@/components/Jobs/UserCredentials.vue'
import UserSkills from '@/components/Jobs/UserSkills.vue'
import ForemanListing from '@/components/Dashboard/ForemanListing.vue'
import EstimatorListing from '@/components/Dashboard/EstimatorListing.vue'
import AccountingListing from '@/components/Dashboard/AccountingListing.vue'
import ProjectManagerDashboardListing from '@/components/Dashboard/ProjectManagerDashboardListing.vue'
import AiChat from '@/components/Ai/AiChat.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/timesheets',
    name: 'Timesheet',
    component: Timesheet,
  },
  {
    path: '/assignments',
    name: 'Assignments',
    component: Assignments,
  },
  {
    path: '/lineups',
    name: 'Lineups',
    component: Lineups,
  },
  {
    path: '/jobs',
    name: 'JobListing',
    component: JobListing,
  },
  {
    path: '/job/:id',
    name: 'JobEdit',
    component: JobEdit,
  },
  {
    path: '/job',
    name: 'JobAdd',
    component: JobAdd,

  },
  {
    path: '/foreman',
    name: 'ForemanListing',
    component: ForemanListing,
  },
  {
    path: '/estimator',
    name: 'EstimatorListing',
    component: EstimatorListing,
  },
  {
    path: '/accounting',
    name: 'AccountingListing',
    component: AccountingListing,
  },
  {
    path: '/project-manager',
    name: 'ProjectManagerDashboardListing',
    component: ProjectManagerDashboardListing,
  },
  {
    path: '/ai-chat',
    name: 'AiChat',
    component: AiChat,
    meta: {
      aiChatRoleRestricted: true,
    },
  },


  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/auth/password/reset',
    name: 'RequestPasswordReset',
    component: RequestPasswordReset,
  },
  {
    path: '/auth/reset/:token/:email',
    name: 'PasswordResetForm',
    component: PasswordResetForm,
  },
  {
    path: '/timesheets/view/:id',
    name: 'TimesheetDetail',
    component: TimesheetDetail,
  },
  {
    path: '/my-credentials/:id',
    name: 'UserCredentials',
    component: UserCredentials,
  },
  {
    path: '/my-skills/:id',
    name: 'UserSkills',
    component: UserSkills,
  },
  {
    path: '/timesheets/add',
    name: 'AddTimesheet',
    component: AddTimesheet,
  },

  {
    path: '/timesheets/currentView/:id',
    name: 'TimesheetDetailCurrent',
    component: TimesheetDetailCurrent,
  },
  {
    path: '/timesheets/:id/add/:detailId?',
    name: 'AddCurrentTimesheet',
    component: AddCurrentTimesheet,
  },


]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (!to.meta || !to.meta.aiChatRoleRestricted) {
    next()
    return
  }

  const permissions = JSON.parse(localStorage.getItem('permissions') || '{}')
  const canAccessAiChat = Boolean(
    (permissions.executive && permissions.executive.flag) ||
    (permissions.accounting && permissions.accounting.flag) ||
    (permissions.project_manager && permissions.project_manager.flag) ||
    (permissions.estimator && permissions.estimator.flag) ||
    (permissions.admin && permissions.admin.flag)
  )

  if (canAccessAiChat) {
    next()
    return
  }

  next('/timesheets')
})

export default router
